import React from "react";
import { SubscriptionProvider } from "../../context/SubscriptionContext";
import AvailableSubscriptionPlans from "./AvailableSubscriptionPlans";

export default function Subscription() {
  return (
    <SubscriptionProvider>
      <AvailableSubscriptionPlans />
    </SubscriptionProvider>
  );
}
